import React from "react";
import { FaRegQuestionCircle } from "react-icons/fa";
import Tooltip from "rc-tooltip";
import DOMPurify from "dompurify";
import "rc-tooltip/assets/bootstrap_white.css";
import "./styles/FormTooltip.scss";

const toolTipContent = (content) => (
  <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content, { ADD_ATTR: ["target"] }) }} />
);

class FormTooltip extends React.Component {
  render() {
    const { content, className, customClassName } = this.props;

    return (
      <span className={`simpleform-tooltip form-tooltip ${customClassName}`}>
        <Tooltip
          trigger={["focus", "click", "hover"]}
          placement="right"
          className={className}
          overlay={() => toolTipContent(content)}
          getTooltipContainer={() => document.querySelector(".ReactModalPortal")}
        >
          <button type={"button"} value="tooltip" tabIndex={0}>
            <FaRegQuestionCircle size={"1.1em"} />
            <span className="usa-sr-only">Click tooltip for more information</span>
          </button>
        </Tooltip>
      </span>
    );
  }
}

export default FormTooltip;
